export default __webpack_public_path__ + "static/Celebrity-spotting-during-fashion-week-ba8363922a2fb4818005be5b8571812c.jpg";